import logo_multiscan from '@/assets/imagens/logo_multiscan.png';
import { Sidebar, SidebarContent, SidebarGroup, SidebarGroupContent, SidebarHeader, SidebarMenu, SidebarMenuButton, SidebarMenuItem } from '@/components/ui/sidebar';
import { MenuItems } from "@/utils/constants";
import SideMenuButton from "../sideMenuButton";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { ChevronDown } from 'lucide-react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import logo_avatar from '@/assets/imagens/logo_avatar.png';
import { useAppDispatch, useAppSelector } from '@/store';
import { useAuthActions, useAuthState } from '@/store/auth';
import { encurtarNome } from '@/utils/funcoes';

export default function SideMenu() {
    const { nome } = useAppSelector(useAuthState)
    const { logout } = useAuthActions;
    const dispatch = useAppDispatch()
    
    return (
        <Sidebar>
            <SidebarHeader className='bg-gray-100'>
                <div className={`logo p-1 transition-all duration-300 delay-500`}>
                    <img
                        src={logo_multiscan}
                        alt='logo'
                        className='w-[200px] bg-none p-3 rounded-md'
                    />
                </div>
                <SidebarMenu className='my-4 p-2 rounded-md border'>
                    <SidebarMenuItem>
                        <DropdownMenu>
                        <DropdownMenuTrigger asChild>
                            <SidebarMenuButton>
                                <Avatar className='flex items-center'>
                                    <AvatarImage src={logo_avatar} className='w-8 h-8' />
                                    <AvatarFallback>MT</AvatarFallback>
                                </Avatar>
                                <div className='font-bold'>
                                    {encurtarNome(nome)}
                                </div>
                            <ChevronDown className="ml-auto" />
                            </SidebarMenuButton>
                        </DropdownMenuTrigger>
                        <DropdownMenuContent className="w-[--radix-popper-anchor-width]">
                            <DropdownMenuItem
                                className="cursor-pointer"
                                onClick={() => dispatch(logout())}
                            >
                                <span>Sair</span>
                            </DropdownMenuItem>
                        </DropdownMenuContent>
                        </DropdownMenu>
                    </SidebarMenuItem>
                </SidebarMenu>
            </SidebarHeader>
            <SidebarContent className='bg-gray-100'>
                <SidebarGroup>
                    <SidebarGroupContent>
                        <SidebarMenu>
                            {MenuItems.map((item, index) => (
                                <SideMenuButton text={item.title} icon={item.icone} link={item.url} key={index} />
                            ))}
                        </SidebarMenu>
                    </SidebarGroupContent>
                </SidebarGroup>
            </SidebarContent>
        </Sidebar>
    );
}
